const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Events Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('Events', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  var fields = 'title,hosts,start_date,end_date,attendees';

  return $resource(appConfiguration.apiUrl + '/learn/v3/events/:subresource/:event/:type/:user', null, {
    get: {params: {subresource: ''}, method: 'GET', isArray: false},
    find: {params: {subresource: '', fields: fields}, method: 'GET', isArray: true},
    create: {params: {subresource: ''}, method: 'POST', isArray: false},
    queryJoinWait: {params: {subresource: 'query-join-wait'}, method: 'POST', isArray: false},
    update: {params: {subresource: ''}, method: 'POST', isArray: false},
    checkIn: {params: {subresource: 'checkin', event: '', type: 'user', user: ''}, method: 'POST', isArray: false},
    checkOut: {params: {subresource: 'checkout', event: '', type: 'user', user: ''}, method: 'POST', isArray: false},
    noAttend: {params: {subresource: 'no-attend', event: '', type: 'user', user: ''}, method: 'POST', isArray: false},
    cancelNoAttend: {params: {subresource: 'cancel-no-attend', event: '', type: 'user', user: ''}, method: 'POST', isArray: false},
    remove: {params: {subresource: ''}, method: 'DELETE', isArray: false}
  });
}]);
